<template>
  <div v-if="loading" class="ui active centered inline loader">
    <div class="ui text loader">{{ $t('loading') }}...</div>
  </div>
  <div v-else>
    <div class="ui clearing segment">
      <div class="centered-header">
        <h2 class="ui header" style="color: #092442;">
          <i class="calendar alternate icon"></i>
          <div class="content">
            Update Visit
          </div>
        </h2>
      </div>
      <div class="ui divider" style="padding-bottom: 20px"></div>

      <visitForm
        :reservation="reservation"
        :visits="visits"
        :doctors="doctors"
        :currentVisit="draftVisit"
        :setVisit="setVisit" 
        :rooms="rooms"
        :paidPackageIds="getPaidPackageIds()"
        :isAbleToChangeClinic="isAbleToChangeClinic()"
      />

      <div class="ui info message" v-if="errors.length">
        <div class="header">
          There were some errors with your submission
        </div>
        <ul class="list" v-for="(error, index) in errors" :key="index">
          <li>{{ error }}</li>
        </ul>
      </div>

      <div
        class="ui blue right floated right labeled icon submit button"
        style="background-color: #092442; margin-top: 20px"
        @click="save()"
      >
        <i class="right arrow icon"></i>
        Save
      </div>
    </div>  
  </div>
</template>

<script>
export default {
  components: {
    visitForm: require('./VisitForm').default
  },
  data() {
    return {
      loading: true,
      reservation: {},
      doctors: [],
      rooms: [],
      visits: [],
      currentVisit: {},
      errors: [],
      draftVisit: {
        id: this.$route.params.visitId,
        clinic_id: this.getClinicId(),
        started_at: null,
        doctor_id: null,
        room_id: null,
        time: null,
        reservation_id: this.$route.params.reservationId,
        packages: [],
        note: null
      },
      transactions: [],
      newVisit: {}
    }
  },
  mounted () {
    this.axios.all([this.getReservation(), this.getDoctorsList(), this.getRoomsList()])
      .then(this.axios.spread((reservationResponse, doctorsResponse, roomsResponse) => {
        this.reservation = reservationResponse.data.reservation
        
        this.visits = reservationResponse.data.meta.visits
        this.currentVisit = this.visits.find(v => v.id === Number(this.$route.params.visitId))
        this.rooms = roomsResponse.data
        this.transactions = reservationResponse.data.meta.transactions

        this.doctors = doctorsResponse.data
        this.draftVisit.doctor_id = this.currentVisit.doctor_id
        this.draftVisit.room_id = this.currentVisit.room_id
        this.draftVisit.clinic_id = this.currentVisit.clinic_id
        this.draftVisit.time = this.currentVisit.time
        this.draftVisit.started_at = this.currentVisit.started_at
        this.draftVisit.note = this.currentVisit.note

        this.draftVisit.packages = this.currentVisit.visit_details.flatMap(vd => ({
          package_id: vd.package_id,
          quantity: vd.quantity,
          actual_quantity: vd.actual_quantity,
          remainder: vd.remainder
        }))
        this.loading = false
      }))
  },
  methods: {
    isAbleToChangeClinic () {
      return !this.currentVisit.started_at
    },
    setVisit(visit) {
      this.newVisit = window._.cloneDeep(visit)
    },
    getDoctorsList() {
      return this.$http.get('doctors/list');
    },
    getReservation() {
      return this.$http.get(`reservations/${this.$route.params.reservationId}`)
    },
    getRoomsList() {
      return this.$http.get(`rooms`, {
        params: {
          clinic_id: this.getClinicId()
        }
      })
    },
    isPackagesVaild () {
      const isPackagesVaild = this.newVisit.packages && this.newVisit.packages.length > 0
      
      if (!isPackagesVaild) {
        this.errors.push('You must add packages to the visit')
      }

      return isPackagesVaild
    },
    isClinicValid () {
      const isClinicValid = !!this.newVisit.clinic_id
      
      if (!isClinicValid) {
        this.errors.push('You must choose clinic')
      }

      return isClinicValid
    },
    isDoctorValid () {
      const isDoctorValid = !!this.newVisit.doctor_id
      
      if (!isDoctorValid && this.getVisitRequiredSource() === this.VisitRequiredFields.DOCTOR) {
        this.errors.push('You must choose doctor')
      }

      return isDoctorValid || this.getVisitRequiredSource() != this.VisitRequiredFields.DOCTOR
    },
    isRoomValid () {
      const isRoomValid = !!this.newVisit.room_id
      
      if (!isRoomValid && this.getVisitRequiredSource() === this.VisitRequiredFields.ROOM) {
        this.errors.push('You must choose room')
      }

      return isRoomValid || this.getVisitRequiredSource() != this.VisitRequiredFields.ROOM
    },
    isTimeValid () {
      const isTimeValid = !!this.newVisit.time
      
      if (!isTimeValid) {
        this.errors.push('You must choose valid time')
      }

      return isTimeValid
    },
    validateCurrentVisit() {
      return this.isPackagesVaild() && this.isClinicValid() && this.isDoctorValid() && this.isTimeValid()
    },
    visitFormat() {
      this.newVisit.packages = this.newVisit.packages.filter(p => p.quantity && p.quantity > 0)
    },
    save() {
      this.visitFormat()
      const isVisitValid = this.validateCurrentVisit()
      if (isVisitValid) {
        this.$http.put(`reservation_visits/${this.$route.params.reservationVisitId}`, {
          visit: this.newVisit
        }).then(response => {
          this.navigateTo(`Show_Visit`, {
            key: 'params',
            value: { reservationVisitId: response.data.id }
          })
        })
      }
    },
    getPaidPackageIds() {
      return this.reservation.reservations_packages.map(rp => {
        return {
          id: rp.package_id,
          name: rp.package.name,
          totalPrice: this.packageTotalPrice(rp),
          totalPaid: this.totalTransactionForPackage(rp),
          remainder: this.packageTotalPrice(rp) - this.totalTransactionForPackage(rp)
        }
      }).filter(p => this.isHalfPaid(p) || !this.settings[1].value).map(p => p.id)
    },
    isHalfPaid(p) {
      return p.totalPaid / p.totalPrice > 0.48
    },
    packageTotalPrice(reservationPackage) {
      return Number(reservationPackage.repeated) * Number(reservationPackage.package.unit_price)
        * Number(reservationPackage.package.quantity)
    },
    totalTransactionForPackage(reservationPackage) {
      const transactionIds = this.reservation.reservation_transactions
        .filter(rt => rt.package_id === reservationPackage.package_id)
        .map(rt => rt.transaction_id)
        
      return window._.sumBy(this.transactions, transaction => {
        return transactionIds.includes(transaction.id) ? transaction.amount : 0
      })
    }
  },
}
</script>

<style scoped>
  .centered-header {
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/visits/UpdateVisit.vue